import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0d98b214"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20 p20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item");
  const _component_el_tag = _resolveComponent("el-tag");
  const _component_el_descriptions = _resolveComponent("el-descriptions");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    class: "mb20",
    type: "primary",
    icon: "ArrowLeft",
    circle: "",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back(-1))
  }), _createVNode(_component_el_descriptions, {
    border: "",
    title: "账单详情",
    column: 4
  }, {
    default: _withCtx(() => [_createVNode(_component_el_descriptions_item, {
      label: "订单号",
      span: "4"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.orderNo), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "起运地",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.loadAddress), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "卸货地",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.unLoadAddress), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "装车磅单",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.loadingActualWeight / 100) + "吨", 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "卸货磅单",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.unloadingActualWeight / 100) + "吨", 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "托运人",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.forwarderName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "承运人",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.driverName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "承运车辆 ",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.vehicleNo), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "车长车型",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(($setup.data.info?.carLength || []).join("、")) + " | " + _toDisplayString(($setup.data.info?.carType || []).join("、")), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "承运货物 ",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.goodsName), 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "运费",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.data.info?.amount / 100) + "元 ", 1)]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "结算状态",
      span: "2"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tag, {
        type: "success"
      }, {
        default: _withCtx(() => [_createTextVNode("已接单")]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_descriptions_item, {
      label: "发票状态",
      span: "2"
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.invoiceSuccessList[$setup.data.info?.invoiceSuccess || 0]), 1)]),
      _: 1
    })]),
    _: 1
  })]);
}